
import Vue from "vue";

export default Vue.extend({
	name: "Flag",
	props: {
        iso: { type: String, default: null },
        title: { type: String, default: null },
        squared: { type: Boolean, default: true },
    },
    computed: {
        flagIconClass: function() {
            return ((!!this.squared) ? 'flag-icon-squared ' : '') + 'flag-icon-' + this.iso.toLowerCase();
        }
    }
});

